import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const POM_THEME_LIGHT: Theme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== POM_THEME_LIGHT) {
      fundamental.updateTheme(POM_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
